module.exports = __webpack_public_path__ + "img/tottenham2.61dedcc1.jpg";